import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { LMFormRequestService } from '@form/services';
import { LMRadiobuttonBaseComponent } from './lm-radiobutton-base.component';

@Component({
  selector:    'lm-radiobutton-soho',
  standalone: false,
  templateUrl: './lm-radiobutton-soho.component.html',
  styleUrls:   [ 'lm-radiobutton-soho.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMRadiobuttonSohoComponent extends LMRadiobuttonBaseComponent implements OnInit, OnDestroy {

  constructor(protected lmFormRequestService: LMFormRequestService,
              protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFormRequestService, lmFieldServiceAdapter);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
